import * as i18next from "i18next";

export const i18n = i18next.init({
	resources: {
		de: {
			translations: {
				login: {
					heading: "Bitte anmelden!",
					usernameLabel: "Benutzername",
					passwordLabel: "Passwort",
					submitLabel: "Anmelden"
				},
				navigation: {
					dashboard: "Tagesübersicht",
					dayOverview: "Tagesübersicht",
					bookingPlan: "Belegungsplan",
					bookingPlanList: "Belegunsliste",
					inquiryList: "Anfragen",
					payments: "Zahlungen",
					printviews: "Druckansichten",
					settings: "Einstellungen",
					adminArea: "Adminbereich",
					availabilities: "Verfügbarkeiten",
				},
				datepicker: {
					today: "Heute",
					yesterday: "Gestern",
					tomorrow: "Morgen",
					ok: "OK",
					cancel: "Abbrechen",
					clear: "Heute"
				}
			}
		}
	},
	fallbackLng: "de",
	debug: false,
	ns: ["translations"],
	defaultNS: "translations",
	interpolation: {
		escapeValue: false,
		formatSeparator: "."
	},
	react: {
		wait: true
	}
});
